import { render, staticRenderFns } from "./LocalIcon.vue?vue&type=template&id=4d303a3c&scoped=true&"
import script from "./LocalIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LocalIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d303a3c",
  null
  
)

export default component.exports